module.exports = __webpack_public_path__ + "static/media/clemente_castor_3.ecb6066a.jpg";